import { useHotkeys } from "react-hotkeys-hook";

class HotkeyManager {
  private pisMac = navigator.userAgent.includes("Mac");
  isSubmitPostHotkey(event: {
    key: string;
    metaKey: boolean;
    ctrlKey: boolean;
  }) {
    if (this.isMac()) {
      return event.metaKey && event.key === "Enter";
    }
    return event.ctrlKey && event.key === "Enter";
  }

  useSubmitPostHotkey(func: () => void, devs: unknown[]) {
    const hotkeyStr = this.isMac() ? "meta+enter" : "ctrl+enter";
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useHotkeys(
      hotkeyStr,
      func,
      {
        enableOnFormTags: true,
        enableOnContentEditable: true,
      },
      devs
    );
  }

  isMac() {
    return this.pisMac;
  }
}

export const hotkeyManager = new HotkeyManager();
